import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card } from '../../components/ui/card';
import { toast } from 'sonner';
import { api } from '../../utils/api';
import { Building2 } from 'lucide-react';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = await api.login(formData.email, formData.password);
      
      // Store token and agent data
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('agent', JSON.stringify(data.agent));
      
      toast.success('Connexion réussie');
      navigate('/bo/dashboard');
    } catch (error) {
      toast.error('Erreur', {
        description: error.message || 'Email ou mot de passe incorrect'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left: Brand */}
      <div className="hidden lg:flex flex-col justify-center p-12 bg-primary text-primary-foreground">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Building2 className="w-16 h-16 mb-6" />
          <h1 className="text-4xl font-bold mb-4">Estimation Réelle</h1>
          <p className="text-lg opacity-90 max-w-md">
            Plateforme de gestion des leads pour experts immobiliers en Suisse Romande.
          </p>
          <div className="mt-8 space-y-3">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-white/80" />
              <p className="opacity-80">Gestion centralisée des leads</p>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-white/80" />
              <p className="opacity-80">Page personnalisée par agent</p>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-white/80" />
              <p className="opacity-80">Suivi et statistiques en temps réel</p>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Right: Login Form */}
      <div className="flex items-center justify-center p-6 sm:p-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="w-full max-w-md"
        >
          <Card className="p-8">
            <div className="mb-8">
              <h2 className="text-2xl font-bold mb-2">Connexion</h2>
              <p className="text-muted-foreground">Accédez à votre espace agent</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
                  required
                  data-testid="login-email-input"
                />
              </div>

              <div>
                <Label htmlFor="password">Mot de passe</Label>
                <Input
                  id="password"
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData(prev => ({ ...prev, password: e.target.value }))}
                  required
                  data-testid="login-password-input"
                />
              </div>

              <Button
                type="submit"
                className="w-full"
                disabled={loading}
                data-testid="login-submit-button"
              >
                {loading ? 'Connexion...' : 'Se connecter'}
              </Button>
            </form>

            <div className="mt-6 p-4 bg-muted/50 rounded-md">
              <p className="text-xs text-muted-foreground">
                <strong>Compte de test :</strong><br />
                Email: admin@valeur-immo.ch<br />
                Mot de passe: admin123
              </p>
            </div>
          </Card>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;
